import $ from 'jquery';
//import "lightslider/dist/js/lightslider";
import "slick-carousel/slick/slick.min";
import mapMarkerImage from "../../images/buyMap/map-marker.png";

"use strict";
!function (t) {
    t(document).ready(function () {
        window.onscroll = function () {
            !function () {
                window.pageYOffset + n + a + o.height() + 2 * s,
                window.pageYOffset <= f - a && (e.fadeOut(400),
                    o.css({
                        position: "absolute",
                        top: "-85px"
                    }));
                window.pageYOffset > f - a && (e.fadeIn(400),
                    o.css({
                        position: "fixed",
                        top: "130px"
                    }))
            }(),
            t(window).width() > 767 && window.pageYOffset + n + a + o.height() + 2 * s >= c - a && "absolute" !== o.css("position") && (o.css("position", "absolute"),
                o.css("top", function () {
                    return (c - r - a - o.height() - 2 * s)
                }))
        }
        ;
        var e = t(".apartment-navbar")
            , n = t(".apartment-navbar").height()
            , o = t(".agent-card")
            , s = 16
            , a = 20
            , i = t(".acf-map-apartment-card")
            , f = null
            , u = t(".apartment-section-8")
            , c = null
            , p = t(".apartment-section-2")
            , r = null;
        t.setOffsetsTop = function () {
            setTimeout(function () {
                f = i.offset().top,
                    c = u.offset().top,
                    r = p.offset().top
            }, 200)
        }
            ,
            t.setOffsetsTop();
    })
}(jQuery);

!function(t) {

    function initPinchZoom() {
        const imageContainer = document.querySelector('.lg-current .lg-img-wrap');

        let minScale = 1;
        let maxScale = 4;
        let imageWidth;
        let imageHeight;
        let containerWidth;
        let containerHeight;
        let displayImageX = 0;
        let displayImageY = 0;
        let displayImageScale = 1;

        let displayDefaultWidth;
        let displayDefaultHeight;

        let rangeX = 0;
        let rangeMaxX = 0;
        let rangeMinX = 0;

        let rangeY = 0;
        let rangeMaxY = 0;
        let rangeMinY = 0;


        let displayImageCurrentX = 0;
        let displayImageCurrentY = 0;
        let displayImageCurrentScale = 1;


        function resizeContainer() {
            containerWidth = imageContainer.offsetWidth;
            containerHeight = imageContainer.offsetHeight;
            if (displayDefaultWidth !== undefined && displayDefaultHeight !== undefined) {
                displayDefaultWidth = displayImage.offsetWidth;
                displayDefaultHeight = displayImage.offsetHeight;
                updateRange();
                displayImageCurrentX = clamp(displayImageX, rangeMinX, rangeMaxX);
                displayImageCurrentY = clamp(displayImageY, rangeMinY, rangeMaxY);
                updateDisplayImage(
                    displayImageCurrentX,
                    displayImageCurrentY,
                    displayImageCurrentScale);
            }
        }

        function clamp(value, min, max) {
            return Math.min(Math.max(min, value), max);
        }

        function clampScale(newScale) {
            return clamp(newScale, minScale, maxScale);
        }

        resizeContainer();

        window.addEventListener('resize', resizeContainer, true);

        const displayImage = document.querySelector('.lg-current img');
        imageWidth = displayImage.width;
        imageHeight = displayImage.height;
        displayImage.addEventListener('mousedown', e => e.preventDefault(), false);
        displayDefaultWidth = displayImage.offsetWidth;
        displayDefaultHeight = displayImage.offsetHeight;
        rangeX = Math.max(0, displayDefaultWidth - containerWidth);
        rangeY = Math.max(0, displayDefaultHeight - containerHeight);

        imageContainer.addEventListener('wheel', e => {
            displayImageScale = displayImageCurrentScale = clampScale(displayImageScale + (e.wheelDelta / 800));
            updateRange();
            displayImageCurrentX = clamp(displayImageCurrentX, rangeMinX, rangeMaxX);
            displayImageCurrentY = clamp(displayImageCurrentY, rangeMinY, rangeMaxY);
            updateDisplayImage(displayImageCurrentX, displayImageCurrentY, displayImageScale);
        }, false);

        function updateDisplayImage(x, y, scale) {
            const transform = 'translateX(' + x + 'px) translateY(' + y + 'px) translateZ(0px) scale(' + scale + ',' + scale + ')';
            displayImage.style.transform = transform;
            displayImage.style.WebkitTransform = transform;
            displayImage.style.msTransform = transform;
        }

        function updateRange() {
            rangeX = Math.max(0, Math.round(displayDefaultWidth * displayImageCurrentScale) - containerWidth);
            rangeY = Math.max(0, Math.round(displayDefaultHeight * displayImageCurrentScale) - containerHeight);

            rangeMaxX = Math.round(rangeX / 2);
            rangeMinX = 0 - rangeMaxX;

            rangeMaxY = Math.round(rangeY / 2);
            rangeMinY = 0 - rangeMaxY;
        }

        const hammertime = new Hammer(imageContainer);

        hammertime.get('pinch').set({ enable: true });
        hammertime.get('pan').set({ direction: Hammer.DIRECTION_ALL });

        hammertime.on('pan', ev => {
            displayImageCurrentX = clamp(displayImageX + ev.deltaX, rangeMinX, rangeMaxX);
            displayImageCurrentY = clamp(displayImageY + ev.deltaY, rangeMinY, rangeMaxY);
            updateDisplayImage(displayImageCurrentX, displayImageCurrentY, displayImageScale);
        });

        hammertime.on('pinch pinchmove', ev => {
            displayImageCurrentScale = clampScale(ev.scale * displayImageScale);
            updateRange();
            displayImageCurrentX = clamp(displayImageX + ev.deltaX, rangeMinX, rangeMaxX);
            displayImageCurrentY = clamp(displayImageY + ev.deltaY, rangeMinY, rangeMaxY);
            updateDisplayImage(displayImageCurrentX, displayImageCurrentY, displayImageCurrentScale);
        });

        hammertime.on('panend pancancel pinchend pinchcancel', () => {
            displayImageScale = displayImageCurrentScale;
            displayImageX = displayImageCurrentX;
            displayImageY = displayImageCurrentY;
        });
    }

    t(document).ready(function() {
        var e = t(".slick")
            , a = t(".google-map")
            , n = 0
            , s = t(".apartment-address").text().split(",");
        s.splice(1, 1),
            s = s.join();
        var i = '<div class="gallery-toolbar circularstd-medium"><span class="gallery-toolbar__address">' + s + '</span>|<span class="gallery-toolbar__cost">' + t(".apartment-price").text();
            i += (t("#roomValue").text() !== "" ?'</span>|<span class="gallery-toolbar__beds">' + t("#roomValue").text() + " "+t("#roomText").text() : "asd"),
            i += (t("#bedroomValue").text() !== "" ? '</span>|<span class="gallery-toolbar__beds">' + t("#bedroomValue").text() + " "+t("#bedroomText").text() : ""),
            i += '</span>|<span class="gallery-toolbar__baths">' + t(".apartment-bathrooms").text() + " "+t(".bathrooms-text").text(),
            i += '</span>|<span class="gallery-toolbar__size">' + t(".apartment-sqm").text() + " "+t(".sqm-text").text()+ "</span></div>";
        e.on("onBeforeOpen.lg", function() {
            t("body").addClass("overflow-hidden")
        }),
            e.on("onAfterOpen.lg", function() {
                t('<span class="lg-toogle-thumb lg-icon"></span>').insertAfter(".lg-close"),
                "Sold" === t(".sold-status").val() && t('<div class="sold sold--gallery">sold</div>').insertBefore(".lg"),
                    t(".lg-toogle-thumb").click(function() {
                        t(".lg-outer").toggleClass("lg-thumb-open")
                    }),
                    t('<span class="lg-open lg-open_map lg-icon"></span>').insertAfter(".lg-toogle-thumb"),
                    t(".lg-open_map").click(function() {
                        e.data("lightGallery").destroy(!1),
                            setTimeout(function() {
                                a.trigger("click")
                            }, 200)
                    }),
                    t(i).insertAfter("#lg-counter"),
                    t(".lg-item").append('<div class="lg-dont-download"></div>'),
                t(window).width() <= 576 && setTimeout(function() {
                    t(".lg-dont-download").on("click touchstart", function() {
                        t(".lg-outer").toggleClass("lg-hide-items lg-thumb-open")
                    })
                }, 1e3)
                initPinchZoom();
                setTimeout(function() {
                    t(".lg-outer").removeClass("lg-thumb-open")
                }, 2000)
            }),
            e.on("onAfterSlide.lg", function(t, e, a) {
                initPinchZoom();
                n = a
            }),
            e.on("onBeforeClose.lg", function(e) {
                t("body").removeClass("overflow-hidden")
                    /*lightSlider.slick("slickGoTo", n - 1)*/
            });
        var o = t(window).width() < 767 ? "100%" : "80%";

        if(document.querySelector('.slick-track')){
            a.lightGallery({
                selector: "li",
                iframeMaxWidth: o,
                closable: true,
            })
        }

        a.on("onBeforeOpen.lg", function() {
            t("body").addClass("overflow-hidden")
        }),
        a.on("onAfterOpen.lg", function() {
            t('<span class="lg-open lg-open_gallery lg-icon"></span>').insertAfter(".lg-toogle-thumb"),
            t(i).insertAfter("#lg-counter"),
            t(".lg-open_gallery").click(function() {
                a.data("lightGallery").destroy(false);
                var $targetImage = t(".slick").find('img[data-id="' + n + '"]');
                $targetImage.trigger("click");
            });

        }),
        a.on("onBeforeClose.lg", function(e) {
            t("body").removeClass("overflow-hidden")
        })
    })
}(jQuery);
$(function () {

    let $gallery = $(".slick").lightGallery({
        share: false,
        download: false,
        closable: !1,
        enableSwipe: false,
        enableThumbSwipe: false,
        zoom: false,
        autoplayControls:false,
        zoomFromOrigin: false,
    });

    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
        $gallery.on('onSlideClick.lg', function(){
            $('.lg-toolbar').toggle();
            $('.lg-thumb-outer').toggle();
        });
    }

    var lightSlider = $(".slick").slick({
        infinite: !0,
        dots: !1,
        variableWidth: !0,
        draggable: !1,
        nextArrow: '<i class="fas fa-chevron-circle-right"></i>',
        prevArrow: '<i class="fas fa-chevron-circle-left"></i>',
        accessibility: !0
    });

    $(document).on("keydown", function (t) {
        37 == t.keyCode && lightSlider.slick("slickPrev"),
        39 == t.keyCode && lightSlider.slick("slickNext")
    });

    $(document).find(".slick-list").attr("tabindex", 0).focus();

    $(".js-open-lg-images").click(function () {
        $('.slick img[data-id="0"]').trigger("click")
    });

    $(document).find(".slick-cloned").on("click", function () {
        $('.slick .slick-slide:not(".slick-cloned") img[data-id="' + $(this).find("img").data("id") + '"]').trigger("click")
    });

    $(".js-open-lg-floorplan").click(function () {
        $('.slick img[data-id="floorplan-image"]').trigger("click")
    });


    initMap();
    var $body = $("body");

    $body.on("click","#agent-footer-form-close",function(){
        $(".agent-footer").removeClass("show")
    });

    $body.on("click","#agent-footer-form-close",function(){
        $(".agent-footer").removeClass("show");
        const button = $("#footer-contact-agent-button");
        button.data("status","base");
        button.html(button.data("base-text"));
        $body.removeClass("body-no-scroll");
    });

    $body.on("click","#footer-contact-agent-button",function(){
        const dataStatus = $(this).data("status");
        if(dataStatus === "base"){
            $(".agent-footer").addClass("show");
            $(this).data("status","form");
            $(this).html($(this).data("send-text"));
            $body.addClass("body-no-scroll");
        }else{
            //$("#send-to-agent-form-footer").trigger("submit");
        }

    });

    $body.on("click","#contact-Agent",function(){
        $(".agent-form").addClass("d-block");
        $("#contact-agent-button-container").hide();
        $("#send-contact-agent-container").removeClass("d-none");
        setTimeout(() => {
            $(".agent-form").addClass("show");
        },1)
    });
    $body.on("click","#agent-form-close",function(){

        $(".agent-form").removeClass("show");
        setTimeout(function(){
            $(".agent-form").removeClass("d-block");
            $("#contact-agent-button-container").show();
            $("#send-contact-agent-container").addClass("d-none");
        },200);
    });
});


const initMap = () => {
    const $mapsContainer = $('#buyApartmentMap');
    const map = new google.maps.Map($mapsContainer[0], {
        center: new google.maps.LatLng(parseFloat($mapsContainer.data("lat")), parseFloat($mapsContainer.data("lng"))),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        styles: [{featureType: "poi", stylers: [{visibility: "off"}]}],
        disableDefaultUI: !0,
        zoom: 17
    });

    const marker =  new google.maps.Marker({
        icon: mapMarkerImage,
        label: ".",
        position: {
            lat: parseFloat($mapsContainer.data("lat")),
            lng: parseFloat($mapsContainer.data("lng"))
        },
    });
    new MarkerClusterer(
        map,
        [marker],{
            imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
        }
    );
};
